var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ card: true, loading: _vm.value },style:({ height: _vm.height })},[_vm._t("default"),(_vm.value)?[_c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":require("../assets/images/loading.svg"),"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.getLabel))])])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }